// Manitoba RCMP Detachments List
// Source: https://rcmp.ca/en/manitoba/detachments

export const manitobaDetachments = [
  "Manitoba RCMP Headquarters",
  "Amaranth Detachment",
  "Ashern Detachment",
  "Beausejour Detachment",
  "Berens River Detachment",
  "Bloodvein Detachment",
  "Boissevain Detachment",
  "Brandon Detachment",
  "Carberry Detachment",
  "Carman Detachment",
  "Chemawawin Cree Nation Detachment",
  "Churchill Detachment",
  "Cranberry Portage Detachment",
  "Cross Lake Detachment",
  "Dauphin Detachment",
  "Deloraine Detachment",
  "Elphinstone Detachment",
  "Emerson Detachment",
  "Falcon Beach Detachment",
  "Fisher Branch Detachment",
  "Flin Flon Detachment",
  "Gillam Detachment",
  "Gimli Detachment",
  "Gods Lake Narrows Detachment",
  "Grand Marais Detachment",
  "Grand Rapids Detachment",
  "Gypsumville Detachment",
  "Hamiota Detachment",
  "Headingley Detachment",
  "Island Lake Detachment",
  "Killarney Detachment",
  "Lac du Bonnet Detachment",
  "Leaf Rapids Detachment",
  "Little Grand Rapids Detachment",
  "Lundar Detachment",
  "Lynn Lake Detachment",
  "Manitou Detachment",
  "Melita Detachment",
  "Minnedosa Detachment",
  "Moose Lake Detachment",
  "Morden Detachment",
  "Morris Detachment",
  "Neepawa Detachment",
  "Nelson House Detachment",
  "Norway House Detachment",
  "Oakbank Detachment",
  "Oxford House Detachment",
  "Peguis Detachment",
  "Pinawa Detachment",
  "Poplar River Detachment",
  "Portage La Prairie Detachment",
  "Powerview Detachment",
  "Pukatawagan Detachment",
  "Red River North Detachment",
  "Reston Detachment",
  "Roblin Detachment",
  "Russell Detachment",
  "Selkirk Detachment",
  "Shamattawa Detachment",
  "Shoal Lake Detachment",
  "Snow Lake Detachment",
  "Souris Detachment",
  "South Indian Lake Detachment",
  "Sprague Detachment",
  "St. Pierre-Jolys Detachment",
  "Ste. Rose du Lac Detachment",
  "Steinbach Detachment",
  "Stonewall Detachment",
  "Swan River Detachment",
  "The Pas Detachment",
  "Thompson Detachment",
  "Thompson Detachment (rural)",
  "Treherne Detachment",
  "Virden Detachment",
  "Wabowden Detachment",
  "Wasagaming Detachment",
  "Whitemouth Detachment",
  "Winnipeg Airport Detachment",
  "Winnipegosis Detachment"
];

export default manitobaDetachments;
